import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
    name: "user",
    initialState: {
        user: null
    },
    reducers: {
        putUser: (state, action) => {
            state.user = action.payload;
        },
        removeUser: (state) => {
            state.user = null
        }
    }
});

export const {putUser, removeUser} = userSlice.actions;

export const selectUser = (state) => state.user.user;

export default userSlice.reducer;